import { Component, inject, Input, OnDestroy, OnChanges, SimpleChanges, ChangeDetectorRef, NgZone } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ProductService } from '../shared/service/product.service';
import { LargeScalePowerGenerationResponse } from '../shared/models/large-scale-power-generation';
import { BaseComponent } from '../base/components/base.component';
import { ApexAxisChartSeries, NgApexchartsModule } from 'ng-apexcharts';
import { CspNonceService } from '../shared/service/csp-nonce.service';
import { ChartOptions, NoxChartDta, NoxChartXY } from '../shared/models/nox-chart';
import moment from 'moment';
import {  Subject } from 'rxjs';


@Component({
    selector: 'app-large-scale-power-generation',
    imports: [TranslateModule, NgApexchartsModule],
    templateUrl: './large-scale-power-generation.component.html',
    styleUrl: './large-scale-power-generation.component.scss'
})
export class LargeScalePowerGenerationComponent extends BaseComponent implements OnDestroy, OnChanges

 {
  @Input() plantID!: string;
  productService = inject(ProductService)
  cdr = inject(ChangeDetectorRef)
  ngZone = inject(NgZone)
  series: ApexAxisChartSeries = [];
 readonly destroy$ = new Subject<void>();
  constructor(private readonly cspNonceService: CspNonceService) {
    super();
  }
  noxChartData: NoxChartDta[] = [];
  noxChartXY: NoxChartXY[] = [];
  showChart = false;
  chartOptions: Partial<ChartOptions> = {
    legend: { show: false }
  };
  

  getPowerGeneration() {

    this.productService.getPowerGenerationData(this.plantID).subscribe({
      next: (response: LargeScalePowerGenerationResponse) => {
        this.clearGraphData()
        let LargeScalePowerGeneration = response?.data?.generationData;
        if (!LargeScalePowerGeneration?.length) return;
        LargeScalePowerGeneration.sort((a: any, b: any) =>a.time- b.time);
        this.noxChartXY = LargeScalePowerGeneration.map(
          (item): NoxChartXY => ({
            x: item.time*1000,
            y: Number.parseFloat(item.todayGeneration.replace('kWh',''))
          })
        );

        this.noxChartData.push({
          name: "Power Generation",
          noxXY: this.noxChartXY,
        })

        this.plotLargeScaleGenerationGraph(this.noxChartData);
        this.showChart = true;
        this.cdr.detectChanges();
      },
      error: (err: any) => {
        this.ngZone.run(() => {
          this.logger.error(err);
        });
      },
    });
  }
  plotLargeScaleGenerationGraph(noxChartData: NoxChartDta[]) {
    this.series = noxChartData.map(item => ({
      name: item.name,
      data: item.noxXY
    }));
    const nonce = this.cspNonceService.getNonce() ?? undefined;
    this.chartOptions = {

      chart: {
        type: 'area',
        nonce: nonce,
        height: '370',
        width: '100%',
       
        toolbar: {
          show: true,
          autoSelected: 'pan',
          export: {
            csv: {
              dateFormatter(timestamp: any) {
                return moment(timestamp).format('YYYY-MM-DD HH:mm:ss a');
              },
            } as any,
          },
          tools: {
            pan: true,
          },
        },

        zoom: {
          enabled: true,
          type: 'x',
          autoScaleYaxis: true
        },
      },

      dataLabels: {
        enabled: false,
      },

      markers: {
        size: 0,
      },

      stroke: {
        curve: 'smooth',
        width: 1,
        colors: ['#808080'],
      },
      fill: {
        type: 'gradient',
        gradient: {
          type: 'horizontal',
          shadeIntensity: 1,
          gradientToColors: ['#769154'],
          opacityFrom: 0.7,
          opacityTo: 0.9,
          colorStops: [
            {
              offset: 0,
              color: '#0D3F7F',
              opacity: 0.7,
            },
            {
              offset: 70,
              color: '#769154',
              opacity: 0.7,
            },
            {
              offset: 100,
              color: '#769154',
              opacity: 0.9,
            },
          ],
        },
      },
      series: this.series,
      xaxis: {
        type: 'datetime',
        labels: {
          datetimeUTC: false,
          formatter: (value: string) =>
            new Date(+value).toLocaleTimeString([], {
              hour: '2-digit',
              minute: '2-digit',
            }),
        },
        title: {
          offsetY: 4,
          text: 'Time (hh:mm)',
        },

      },

      yaxis: {
        tickAmount: 3,
         decimalsInFloat: 0,
        title: {
          text: 'Power Generation (kW)',
        },
        labels: {
        },
      },

      tooltip: {
        x: {
          formatter: (value: number) =>
            new Date(value).toLocaleTimeString([], {
              hour: '2-digit',
              minute: '2-digit',
            }),
        },
        y: {
          formatter: (val: number) => `${val} kW`,
        },
      },

      grid: {
        padding: {
          bottom: 5,
        },
        yaxis: {

          lines: {
            show: true,
            offsetX: 5,
          },
        },

        borderColor: '#2E3440'

      },

      legend: {
        show: true,
      },


    };
  }

  clearGraphData() {
    this.chartOptions = {
      legend: { show: false }
    };
    this.noxChartXY = [];
    this.noxChartData = [];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['plantID'] && this.plantID) {
      this.getPowerGeneration();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
